import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, Col, Icon, Row} from "elemental-react16"
import _ from "lodash"
import Dropzone from "react-dropzone"

import shop from "shop/shop"
import "../../theme/scantex/style/Form.scss"

export default class UploadPage extends Component {
  state = {
    loading:  false,
    error:    false,
    response: false
  }

  constructor(props) {
    super(props)
  }

  render() {
    let {form, response, loading} = this.state
    return (
      <div className="container pt4">
        <div className="">
          <Row>
            <Col sm="1/2">
              <Attachments accept=".jpg,.jpeg,.png"
                           onChange={({files}) => {
                             this.setState({loading: true})
                             console.log(`uploading files`, files)
                             if (files) {
                               shop.service.params(files)
                                 .then( res => res.text())
                                 .then(response => {
                                   this.setState({response, loading: false})
                                   console.log(`response`, response)
                                 })
                             }
                           }}>
                <Button basic>Bilder hinzufügen</Button>
              </Attachments>
            </Col>
            <Col sm="1/2">
              <div>
                <h2>Debug: Formularinhalt</h2>
                <pre>{JSON.stringify(form, null, 2)}</pre>
                <h2>Debug: Server Antwort</h2>
                {response ? <div>
                  <pre>URL: {response.url}</pre>
                  <pre>Status: {response.status}</pre>
                  <pre>Text: {response.statusText}</pre>
                  <pre>{JSON.stringify(response, null, 2)}</pre>
                </div> : null}
              </div>
            </Col>
          </Row>

        </div>
      </div>
    )
  }
}

class Attachments extends React.Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,
    accept:   PropTypes.string
  }

  constructor({onChange, accept = ".jpg,.jpeg,.png,.doc,.pdf"}) {
    super()
    this.state = {
      accept:         accept,
      files:          [],
      loading:        false,
      dropzoneActive: false
    }
  }

  onDragEnter() {
    this.setState({
      dropzoneActive: true
    })
  }

  onDragLeave() {
    this.setState({
      dropzoneActive: false
    })
  }

  onDrop(files) {
    files = _.uniq(files)
    // this.uploadFiles(files)
    this.props.onChange({files})
  }

  render() {
    const {accept, dropzoneActive} = this.state
    const overlayStyle             = {
      position:   "fixed",
      top:        0,
      right:      0,
      bottom:     0,
      left:       0,
      padding:    "2.5em 0",
      background: "rgba(0,0,0,0.5)",
      textAlign:  "center",
      color:      "#fff"
    }
    let {children}                 = this.props || <ButtonUpload/>
    let dropzoneRef
    let {loading}                  = this.state
    return (
      <Dropzone
        ref={(node) => {
          dropzoneRef = node
        }}
        disableClick
        style={{}}
        accept={accept}
        onDrop={this.onDrop.bind(this)}
        onDragEnter={this.onDragEnter.bind(this
        )}
        onDragLeave={this.onDragLeave.bind(this)}
      >
        { dropzoneActive && <div style={overlayStyle}>Drop files...</div> }
        <div
          onClick={() => {
            dropzoneRef.open()
          }}
        >{(loading) ? <Button
          basic
          loading
          color="green"
        ><Icon name="upload"/> Anhänge hinzufügen</Button> : children}</div>
      </Dropzone>
    )
  }
}


const ButtonUpload = () => <Button
  content={this.state.accept}
  icon="upload"
  label={{as: "a", basic: true, pointing: "right", content: "hochladen"}}
  labelPosition="left"
  basic
  color="grey"
/>



// WEBPACK FOOTER //
// ./src/pages/form/UploadPage.js